import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function MachinesPage() {
  const machines = [
    '4 akslet lastbiler med kroghejs',
    '3 akslet trækker',
    '4 akslet blokvogn',
    '3 akslet overførsels anhængere',
    '3 akslet kærre',
    '2 akslet tipsættevogn',
    '4 akslet tipsættevogn',
    'Kraner 35 tm med flyjib',
    'Skov kran',
    '100 stk forskellige containere',
    'Flad lad til halm/juletræer/stammetræ',
    'Jernplader',
    'Vejslæb til at lave grusvej',
    '39 m³ gylletrailer',
    'Buffer kasse 100 m³',
    'Sorteringsanlæg'
  ];

  const materials = [
    'Bundsikring sand / alm sand',
    'Vasket sand',
    'Hvid sandkasse sand',
    'Stabilgrus',
    'Nøddesten',
    'Ærtesten',
    'Perlegrus',
    'Muld',
    'Harpet muld',
    'Knust beton/tegl fint',
    'Knust beton/tegl grov',
    'Knust asfalt',
    'Flis',
    'Granit 11/16 mm',
    'Stenmel'
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Maskiner – Vognmand & Entreprenør DBM aps"
        description="Maskineliste og salg af materialer fra lagerplads hos Vognmand & Entreprenør DBM aps."
      />

      {/* Header Banner */}
      <section
        className="relative bg-cover bg-center bg-no-repeat text-white py-20 sm:py-32 px-4 sm:px-8 border-b-4 border-neutral-800 text-center flex items-center justify-center min-h-[350px] sm:min-h-[440px]"
        style={{
          backgroundImage:
            'url("https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/2026-03-28-15-09-48-1.jpg")',
        }}
      >
        <div className="relative z-10 max-w-4xl mx-auto drop-shadow-lg [text-shadow:_0_2px_10px_rgba(0,0,0,0.8)]">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black tracking-tight text-white">
            Maskiner / salg af materialer
          </h1>
          <div className="mt-6">
            <Link
              to="/kontakt/"
              className="inline-block bg-black hover:bg-neutral-800 text-white font-bold px-8 py-3.5 rounded text-sm uppercase tracking-wider border border-white/30 transition-colors shadow-lg"
            >
              Kontakt os her
            </Link>
          </div>
        </div>
      </section>

      {/* Lists Section */}
      <section className="py-12 px-4 sm:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12">
          
          {/* Machines list */}
          <div className="bg-white p-6 sm:p-8 rounded shadow-md border border-gray-200">
            <h2 className="text-xl font-bold text-gray-900 mb-6 uppercase tracking-wider">
              <span>Maskineliste</span>
            </h2>
            <ul className="space-y-2.5 text-gray-800 text-sm font-medium">
              {machines.map((item, index) => (
                <li key={index} className="flex items-start space-x-2">
                  <span className="text-neutral-800 font-bold">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Materials list */}
          <div className="bg-white p-6 sm:p-8 rounded shadow-md border border-gray-200">
            <h2 className="text-xl font-bold text-gray-900 mb-6 uppercase tracking-wider">
              <span>Materialer vi sælger fra lager plads:</span>
            </h2>
            <ul className="space-y-2.5 text-gray-800 text-sm font-medium">
              {materials.map((item, index) => (
                <li key={index} className="flex items-start space-x-2">
                  <span className="text-neutral-800 font-bold">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="text-center mt-12">
          <Link
            to="/kontakt/"
            className="inline-block bg-gray-900 hover:bg-black text-white font-bold px-10 py-4 rounded uppercase tracking-wider text-sm transition-colors shadow-lg"
          >
            Kontakt os for forespørgsel
          </Link>
        </div>
      </section>
    </div>
  );
}
